export const DEPARTMENT_SCOPE_MESSAGE =
  "This document belongs to another department.";

export const isDepartmentVisibilityActive = (capability) =>
  Boolean(
    capability?.department_visibility &&
      capability?.resolved_via !== "none" &&
      capability?.department_id != null,
  );

export const getDocumentLoadError = (
  result,
  fallbackMessage = "This document couldn't be loaded.",
) => ({
  messageCode: result?.messageCode,
  message:
    result?.messageCode === "OUT_OF_SCOPE"
      ? DEPARTMENT_SCOPE_MESSAGE
      : result?.message || fallbackMessage,
});
